import React from "react";
import axios from "axios";
import AppContext from "./context/AppContext";
import Button from "./components/Custom/Button/Button";
import { Close } from "@material-ui/icons";

export const REACT_APP_CLIENT = process.env.REACT_APP_CLIENT;
const API_URL = process.env.REACT_APP_HOST_URL;
const USER_API_BASE_URL = API_URL + "/reports/";

export const USER_NAME_SESSION_ATTRIBUTE_NAME = "authenticatedUser";
export const MERCHANT_SESSION_ATTRIBUTE_NAME = "loggedInMerchant";

export const Status = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "primary",
  NONE: undefined,
  NOTIFY: "default",
  DANGER: "danger",
};

export const setToast = (showSnackbar, closeSnackbar) => {
  AppContext.toast = { showSnackbar, closeSnackbar };
};

export const showToast = (msgObj) => {
  if (AppContext.toast && AppContext.toast.showSnackbar) {
    AppContext.toast.showSnackbar(msgObj.title + " - " + msgObj.description, {
      variant: msgObj.type ? msgObj.type : "info",
      autoHideDuration: 3500,
      action: (key) => (
        <Button simple onClick={() => AppContext.toast.closeSnackbar(key)}>
          <Close />
        </Button>
      ),
      // preventDuplicate: true,
    });
  }
};

class ApiService {
  fetchMerchants() {
    return axios.get(USER_API_BASE_URL + "merchants");
  }

  fetchMerchantById(merchantId) {
    return axios.get(USER_API_BASE_URL + "merchant?merchantId=" + merchantId);
  }

  fetchMerchantByName(merchantName) {
    return axios.get(
      USER_API_BASE_URL + "merchantByName?merchantName=" + merchantName
    );
  }

  fetchLoggedInMerchant() {
    return this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME);
  }

  fetchUserRoles() {
    return axios.post(API_URL + "/user/fetchAllRoles", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }
  fetchUsers() {
    return axios.post(API_URL + "/user/fetchAllUsers", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchUserMenuUsage(userId, fromDate, toDate) {
    return axios.post(API_URL + "/user/fetchUserMenuUsage", {
      userId: userId,
      fromDate: fromDate,
      toDate: toDate,
    });
  }

  registerLoggedInMerchant(merchant) {
    this.setInSessionStorage(MERCHANT_SESSION_ATTRIBUTE_NAME, merchant);
  }
  fetchMerchantTransactions(
    localFromDate,
    localToDate,
    fromTime,
    toTime,
    statuses,
    orderNo,
    email,
    terminalId,
    acquirerTxnId,
    criteriaTxnId,
    pageNumber,
    accountPoolId,
    acquirerAccountId,
    numberRowPerPage,
    allChbk
  ) {
    return axios.post(API_URL + "/reports/merchantTransactions", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      terminalId: terminalId,
      acquirerTxnId: acquirerTxnId,
      localFromDate: localFromDate,
      localToDate: localToDate,
      fromTime: fromTime,
      toTime: toTime,
      statuses: statuses,
      orderNo: orderNo,
      email: email,
      criteriaTxnId: criteriaTxnId,
      pageNumber: pageNumber,
      accountPoolId: accountPoolId,
      acquirerAccountId: acquirerAccountId,
      numberRowPerPage: numberRowPerPage,
      allChbk: allChbk,
    });
  }

  fetchRejectedTransactions(
    createdDate,
    merchant,
    terminalId,
    orderNo,
    errorCode,
    pageNo,
    rowPerPage
  ) {
    return axios.post(API_URL + "/admfns/rejectedMerchantTransactions", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      createdDate: createdDate,
      merchant: merchant,
      terminal: terminalId,
      orderNo: orderNo,
      errorCode: errorCode,
      pageNo: pageNo,
      rowPerPage: rowPerPage,
    });
  }

  fetchChargebackTransactions(
    fromDate,
    toDate,
    terminalId,
    pageNumber,
    numberRowPerPage,
    isReported
  ) {
    return axios.post(API_URL + "/reports/chbkTransactions", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      terminalId: terminalId,
      fromDate: fromDate,
      toDate: toDate,
      pageNumber: pageNumber,
      numberRowPerPage: numberRowPerPage,
      isReported: isReported,
    });
  }

  postAPI(path, data) {
    if (data == null) data = {};
    return axios
      .post(path, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        showToast({
          type: Status.ERROR,
          title: "Error",
          description: "Error has occured!",
        });
        return error.response;
      });
  }

  changeTransactionStatus(
    transactionId,
    targetStatus,
    gatewayResponseTrackerId,
    transactionInfo,
    signInfo,
    billingDescriptor,
    acquirerAccountId
  ) {
    return axios.post(API_URL + "/reports/updateTransactionStatus", {
      transactionId: transactionId,
      targetStatus: targetStatus,
      gatewayResponseTrackerId: gatewayResponseTrackerId,
      transactionInfo: transactionInfo,
      signInfo: signInfo,
      billingDescriptor: billingDescriptor,
      acquirerAccountId: acquirerAccountId,
    });
  }

  fetchMerchantTerminals() {
    return axios.post(API_URL + "/wire/fetchMerchantTerminals", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchMerchantTerminalsByMerchantId(merId) {
    return axios.post(API_URL + "/wire/fetchMerchantTerminalsById", {
      enitityId: merId,
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchMerchantTerminalsByMerId(merId) {
    return axios.post(API_URL + "/wire/fetchMerchantTerminalsByMerchantId", {
      enitityId: merId,
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  getUserMerchant() {
    return axios.get(API_URL + "/user/getUserMerchant");
  }

  fetchFraudRulesByMerchantId(merId) {
    return axios.post(API_URL + "/wire/fetchFraudRulesById", {
      merchantId: merId,
    });
  }

  fetchFraudRules() {
    return axios.post(API_URL + "/wire/fetchFraudRules", {});
  }

  addFraduRule(fraudName, merId, fraudValue) {
    return axios.post(API_URL + "/wire/addFraudRulesById", {
      merchantId: merId,
      fraudName: fraudName,
      fraudValue: fraudValue,
    });
  }

  fetchAcquirerAccounts() {
    return axios.post(API_URL + "/wire/fetchAcquirerAccounts", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchAcquirerAccountsWithPoolId(poolId) {
    return axios.post(API_URL + "/wire/fetchAcquirerAccounts", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      accountPoolId: poolId,
    });
  }

  updateUser(userObj) {
    return axios.post(API_URL + "/user/updateUser", {
      loggedInUser: this.getFromSessionStorage(
        USER_NAME_SESSION_ATTRIBUTE_NAME
      ),
      request: userObj,
    });
  }

  updateUserMerchant(userObj) {
    return axios.post(API_URL + "/user/updateUserMerchant", {
      merchant: userObj,
    });
  }

  fetchAcquirerAccountsByAcquirer(
    acquirerId,
    id,
    userName,
    mid,
    billingDesc,
    pool,
    rowPerPage,
    pageNo
  ) {
    return axios.post(API_URL + "/admfns/acquirerAccounts", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      acquirerId: acquirerId,
      cardTypeId: id,
      userName: userName,
      mid: mid,
      billingDescriptor: billingDesc,
      accountPoolId: pool,
      rowPerPage: rowPerPage,
      pageNo: pageNo,
    });
  }

  addNewAcquirer(acquirer, callback) {
    return axios.post(API_URL + "/admfns/addNewAcquirer", {
      acquirer: acquirer,
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchChargeTypes() {
    return axios.post(API_URL + "/admfns/fetchChargeTypes", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchMenusByModuleType(moduleType) {
    return axios.post(API_URL + "/admfns/fetchMenusByModuleType", {
      moduleType: moduleType,
    });
  }

  getFeatures(moduleType) {
    return axios.post(API_URL + "/admfns/getFeatures", {
      moduleType: moduleType,
    });
  }

  fetchMenuById(menuId) {
    return axios.post(API_URL + "/admfns/fetchMenuById", {
      menuId: menuId,
    });
  }

  addNewMenu(
    parentMenuId,
    menuText,
    menuToolTip,
    menuIcon,
    menuLink,
    featureId,
    menuSequence
  ) {
    return axios.post(API_URL + "/admfns/addNewMenu", {
      parentMenuId: parentMenuId,
      menuText: menuText,
      menuToolTip: menuToolTip,
      menuIcon: menuIcon,
      menuLink: menuLink,
      featureId: featureId,
      menuSequence: menuSequence,
    });
  }

  updateMenu(
    parentMenuId,
    menuId,
    menuText,
    menuToolTip,
    menuIcon,
    menuLink,
    featureId,
    menuSequence,
    updated
  ) {
    return axios.post(API_URL + "/admfns/updateMenu", {
      parentMenuId: parentMenuId,
      menuId: menuId,
      menuText: menuText,
      menuToolTip: menuToolTip,
      menuIcon: menuIcon,
      menuLink: menuLink,
      featureId: featureId,
      menuSequence: menuSequence,
      updated: updated,
    });
  }

  deleteMenu(menuId) {
    return axios.post(API_URL + "/admfns/deleteMenu", {
      menuId: menuId,
    });
  }

  menuAccessDetails(menuId) {
    return axios.post(API_URL + "/admfns/menuAccessDetails", {
      menuId: menuId,
    });
  }

  fetchChargeFrequencies() {
    return axios.post(API_URL + "/admfns/fetchChargeFrequencies", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchChargeDirection() {
    return axios.post(API_URL + "/admfns/fetchChargeDirection", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  deleteCharge(id) {
    return axios.post(API_URL + "/admfns/deleteCharge", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      id: id,
    });
  }

  fetchChargeById(id) {
    return axios.post(API_URL + "/admfns/fetchChargeById", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      id: id,
    });
  }

  updateCharge(
    chargeName,
    chargeType,
    direction,
    mandatory,
    frequency,
    code,
    chargeMasterId,
    lastUpdated
  ) {
    return axios.post(API_URL + "/admfns/updateCharge", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      name: chargeName,
      type: chargeType,
      direction: direction,
      mandatory: mandatory,
      frequency: frequency,
      code: code,
      id: chargeMasterId,
      lastUpdated: lastUpdated,
    });
  }

  createNewCharge(
    chargeName,
    chargeType,
    direction,
    mandatory,
    frequency,
    code
  ) {
    return axios.post(API_URL + "/admfns/createNewCharge", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      name: chargeName,
      type: chargeType,
      direction: direction,
      mandatory: mandatory,
      frequency: frequency,
      code: code,
    });
  }

  fetchMasterCharges() {
    return axios.post(API_URL + "/wire/fetchMasterCharges", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchEntityChargeDetails(request) {
    return axios.post(API_URL + "/wire/fetchEntityChargeDetails", request);
  }

  fetchWires(request) {
    return axios.post(API_URL + "/wire/fetchWires", request);
  }
  fetchRrWires(request) {
    return axios.post(API_URL + "/wire/fetchRrWires", request);
  }

  // Start Payout APIs
  fetchPayoutPaymentMethods(request) {
    return axios.post(API_URL + "/admfns/payoutPaymentMethods", request);
  }

  fetchPayoutsManage(request) {
    return axios.post(API_URL + "/admfns/managePayouts", request);
  }

  approvePayout(request) {
    return axios.post(API_URL + "/admfns/approveMerchantPayout", request);
  }

  rejectPayout(request) {
    return axios.post(API_URL + "/admfns/rejectMerchantPayout", request);
  }

  settlePayout(request) {
    return axios.post(API_URL + "/admfns/settleMerchantPayout", request);
  }
  // End Payout APIs

  copyTerminalCharges(fromTerminal, toTerminal, fromDate) {
    return axios.post(API_URL + "/wire/copyEntityCharges", {
      fromTerminal: fromTerminal,
      toTerminal: toTerminal,
      fromDate: fromDate,
    });
  }

  createWire(request) {
    return axios.post(API_URL + "/wire/createWire", request);
  }

  createRollingReserveWire(request) {
    return axios.post(API_URL + "/wire/createRollingReserveWire", request);
  }

  fetchExchangeRatesForWire(terminalId, accountId) {
    return axios.post(API_URL + "/wire/fetchExchangeRatesForWire", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      enitityId: terminalId != null ? terminalId : accountId,
      entityType: terminalId != null ? "MERCHANT" : "ACQUIRER",
    });
  }

  addWireCharge(
    fromDate,
    toDate,
    terminalId,
    accountId,
    chargeMasterId,
    chargeValue,
    chargeDescription,
    chargeCurrency,
    arbitrary
  ) {
    return axios.post(API_URL + "/wire/addWireCharge", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      toDate: toDate,
      enitityId: terminalId != null ? terminalId : accountId,
      entityType: terminalId != null ? "MERCHANT" : "ACQUIRER",
      chargeMasterId: chargeMasterId,
      chargeValue: chargeValue,
      chargeDescription: chargeDescription,
      chargeCurrency: chargeCurrency,
      arbitraryCharge: arbitrary ? "N" : "Y",
    });
  }

  deleteWireCharge(wireChargeId) {
    return axios.post(API_URL + "/wire/deleteWireCharge", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      wireChargeId: wireChargeId,
    });
  }

  deleteWire(wireId, terminalId, accountId) {
    return axios.post(API_URL + "/wire/deleteWire", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      wireId: wireId,
      enitityId: wireId,
      entityType: terminalId != null ? "MERCHANT" : "ACQUIRER",
    });
  }

  deleteRrWire(wireId) {
    return axios.post(API_URL + "/wire/deleteRrWire", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      wireId: wireId,
    });
  }
  deleteRrCharge(chargeId) {
    return axios.post(API_URL + "/wire/deleteRrCharge", {
      chargeId: chargeId,
    });
  }

  approveWire(wireId, terminalId, accountId) {
    return axios.post(API_URL + "/wire/approveWire", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      wireId: wireId,
      enitityId: wireId,
      entityType: terminalId != null ? "MERCHANT" : "ACQUIRER",
    });
  }

  settleWire(wireId) {
    return axios.post(API_URL + "/wire/settleWire", {
      wireId: wireId,
    });
  }
  settleRrWire(wireId) {
    return axios.post(API_URL + "/wire/settleRrWire", {
      wireId: wireId,
    });
  }

  uploadTxnStatus(formData) {
    formData.append(
      "merchantId",
      this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME)
    );
    return axios.post(API_URL + "/wire/uploadTxnStatus", formData);
  }

  fetchEarliestRRSettleDate(terminalId) {
    return axios.post(API_URL + "/wire/fetchEarliestRRSettleDate", {
      enitityId: terminalId,
    });
  }

  updateRRStatus(wireId) {
    return axios.post(API_URL + "/wire/updateRRStatus", {
      wireId: wireId,
    });
  }

  fetchWiresForRR(request) {
    return axios.post(API_URL + "/wire/fetchWiresForRR", request);
  }
  fetchRRWireReport(request) {
    return axios.post(API_URL + "/wire/fetchRRWireReport", request);
  }

  fetchRollingReserveReport(request) {
    return axios.post(API_URL + "/wire/fetchRollingReserveReport", request);
  }

  fetchRollingReserveSummary(request) {
    return axios.post(API_URL + "/wire/fetchRollingReserveSummary", request);
  }

  fetchRollingReserveCharge(request) {
    return axios.post(API_URL + "/wire/fetchRollingReserveCharge", request);
  }

  addRrWireCharge(request) {
    return axios.post(API_URL + "/wire/addRrWireCharge", request);
  }

  changePassword(currentPass, newPass, confirmPass, passType) {
    return axios.post(API_URL + "/reports/changePortalPassword", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      currentPass: currentPass,
      newPass: newPass,
      confirmPass: confirmPass,
      passType: passType,
    });
  }

  fetchWirePdf(wireId, filePostfix) {
    axios({
      method: "post",
      url: API_URL + "/wire/fetchWirePdf",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        wireId: wireId,
      },
    })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download =
          "SettlementReport_" + wireId + "_" + filePostfix + ".pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchRrWirePdf(wireId, filePostfix) {
    axios({
      method: "post",
      url: API_URL + "/wire/fetchRrWirePdf",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        wireId: wireId,
      },
    })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], { type: "application/pdf" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = "SettlementReport_" + wireId + "_" + ".pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchWireXls(wireId, filePostfix) {
    axios({
      method: "post",
      url: API_URL + "/wire/fetchWireXls",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        wireId: wireId,
      },
    })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //Build a URL from the file
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = "transactions_" + wireId + "_" + filePostfix + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        //Open the URL on new Windowupl
        //   window.open(fileURL);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchRrWireXls(wireId, filePostfix) {
    axios({
      method: "post",
      url: API_URL + "/wire/fetchRrWireXls",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        wireId: wireId,
      },
    })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //Build a URL from the file
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = "transactions_" + wireId + "_" + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        //Open the URL on new Windowupl
        //   window.open(fileURL);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getFromSessionStorage(key) {
    return sessionStorage.getItem(key);
  }

  setInSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  }

  removeFromSessionStorage(key) {
    sessionStorage.removeItem(key);
  }

  forgetPassword(userName) {
    return axios.post(API_URL + "/user/forgetPassword", {
      userName: userName,
    });
  }

  fetchAllMerchants() {
    return axios.post(API_URL + "/admfns/fetchMerchants", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }
  fetchAllAgents() {
    return axios.post(API_URL + "/admfns/fetchAgents", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchAllCardType() {
    return axios.post(API_URL + "/admfns/fetchAllCardType", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchAllPaymentMode() {
    return axios.post(API_URL + "/admfns/fetchAllPaymentMode", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchAllAcquirers() {
    return axios.post(API_URL + "/admfns/fetchAllAcquirers", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  uploadCardWhitelist(formData) {
    formData.append(
      "merchantId",
      this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME)
    );
    return axios.post(API_URL + "/admfns/uploadCardWhitelist", formData);
  }

  addMerchant(formData) {
    return axios.post(API_URL + "/admfns/addMerchant", {
      merchant: formData,
      loggedInUser: this.getFromSessionStorage(
        USER_NAME_SESSION_ATTRIBUTE_NAME
      ),
    });
  }

  addTerminal(formData) {
    return axios.post(API_URL + "/admfns/addTerminal", {
      terminal: formData,
      loggedInUser: this.getFromSessionStorage(
        USER_NAME_SESSION_ATTRIBUTE_NAME
      ),
    });
  }

  editTerminal(formData) {
    return axios.post(API_URL + "/admfns/editTerminal", {
      terminal: formData,
      loggedInUser: this.getFromSessionStorage(
        USER_NAME_SESSION_ATTRIBUTE_NAME
      ),
    });
  }

  addAmendAcquirerAccount(formData) {
    return axios.post(API_URL + "/admfns/addAmendAcquirerAccount", {
      acquirerAccount: formData,
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchAllStatusUploadConfigs() {
    return axios.post(API_URL + "/admfns/fetchAllStatusUploadConfigs", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchTxnStatusSummary(dt, currDt, selCurr) {
    return axios.post(API_URL + "/admfns/fetchTxnStatusSummary", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: dt,
      toDate: currDt,
      currency: selCurr,
    });
  }

  fetchMonthsTxnSummary(dt, currDt, selCurr) {
    return axios.post(API_URL + "/admfns/fetchMonthsTxnSummary", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: dt,
      toDate: currDt,
      currency: selCurr,
    });
  }
  fetchCurrency() {
    return axios.post(API_URL + "/admfns/getCurrency", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  fetchMenu() {
    return axios.post(API_URL + "/admfns/adminMenu", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  executeJwtAuthenticationService(username, password) {
    return axios
      .post(API_URL + "/txn/AuthToken", {
        username: username,
        secret: password,
        source: "admdashboard",
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          return err.response;
        }
      });
  }

  fetchAllMenu() {
    return axios.post(API_URL + "/admfns/allMenu", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  getUserActions() {
    return axios.post(API_URL + "/admfns/userActionsEnum", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
    });
  }

  userMenuMappings(userId) {
    return axios.post(API_URL + "/admfns/userMenuMappings", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      userId: userId,
    });
  }

  trackMenuClick(menuId) {
    return axios.post(API_URL + "/user/trackMenuClick", {
      menuId: menuId,
    });
  }

  getCurrentUser() {
    return axios.get(API_URL + "/user/getCurrentUser");
  }

  addUserMenuAccess(userId, menuId, actions) {
    return axios.post(API_URL + "/admfns/addUserMenuAccess", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      userId: userId,
      menuId: menuId,
      actions: actions,
    });
  }

  checkMerchantCardWhiteList(merchantId, cardFirstSix, cardEndFour) {
    return axios.post(API_URL + "/admfns/checkMerchantCardWhiteList", {
      merchantId: merchantId,
      cardFirstSix: cardFirstSix,
      cardEndFour: cardEndFour,
    });
  }
  removeUserMenuAccess(userId, menuId) {
    return axios.post(API_URL + "/admfns/removeUserMenuAccess", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      userId: userId,
      menuId: menuId,
    });
  }

  copyUserMenuAccess(sourceId, targetId) {
    return axios.post(API_URL + "/admfns/copyUserMenuAccess", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      sourceId: sourceId,
      targetId: targetId,
    });
  }

  fetchOtherMerchants(id) {
    return axios.post(API_URL + "/admfns/fetchOtherMerchants", {
      id: id,
    });
  }

  checkAccessByMenuAndAction(menuText, action) {
    return axios.post(API_URL + "/admfns/checkAccessByMenuAndAction", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      menuText: menuText,
      action: action,
    });
  }

  verifyAndCorrectTransactionStatus(txnId) {
    return axios.post(API_URL + "/admfns/verifyAndCorrectTransactionStatus", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      txn_id: txnId,
    });
  }

  addMerchantUrl(merchantId, url) {
    return axios.post(API_URL + "/admfns/addMerchantUrl", {
      merchant: merchantId,
      url: url,
    });
  }

  addMerchantIp(merchantId, ip) {
    return axios.post(API_URL + "/admfns/addMerchantIp", {
      merchant: merchantId,
      ip: ip,
    });
  }

  addMerchantCountryWhiteList(terminalId, country) {
    return axios.post(API_URL + "/admfns/addMerchantCountryWhiteList", {
      terminalId: terminalId,
      countryCode: country,
    });
  }

  fetchMerchantUrls(merchantId) {
    return axios.post(API_URL + "/admfns/fetchMerchantUrls", {
      merchant: merchantId,
    });
  }

  fetchMerchantIps(merchantId) {
    return axios.post(API_URL + "/admfns/fetchMerchantIps", {
      merchant: merchantId,
    });
  }

  fetchCountryWhitelist(terminalId) {
    return axios.post(API_URL + "/admfns/fetchCountryWhitelist", {
      terminalId: terminalId,
    });
  }

  removeMerchantUrl(merchantId, id) {
    return axios.post(API_URL + "/admfns/removeMerchantUrl", {
      merchant: merchantId,
      id: id,
    });
  }
  removeMerchantIp(merchantId, id) {
    return axios.post(API_URL + "/admfns/removeMerchantIp", {
      merchant: merchantId,
      id: id,
    });
  }
  removeMerchantCountryWhiteList(id) {
    return axios.post(API_URL + "/admfns/removeMerchantCountryWhiteList", {
      id: id,
    });
  }
  fetchReportedDisputeTxns(
    fromDate,
    toDate,
    disputeStatus,
    merchantId,
    transactionId,
    rowPerPage,
    PageNo
  ) {
    return axios.post(API_URL + "/admfns/getDisputedTxn", {
      //user: this.getFromSessionStorate(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      toDate: toDate,
      disputeStatus: disputeStatus,
      merchantId: merchantId,
      transactionId: transactionId,
      rowPerPage: rowPerPage,
      PageNo: PageNo,
    });
  }

  fetchOnboardingMerchants() {
    return axios.get(API_URL + "/admfns/fetchOnboardingMerchants");
  }

  fetchAllCountry() {
    return axios.get(API_URL + "/admfns/fetchAllCountry");
  }

  fetchMerchantDocuments(merchantId) {
    return axios.get(
      API_URL + "/admfns/fetchMerchantDocuments?merchantUUID=" + merchantId
    );
  }

  registerSuccessfulLogin(username, password) {
    this.setInSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME, username);
    this.setupAxiosInterceptors(this.createBasicAuthToken(username, password));
  }

  registerSuccessfulLoginForJwt(username, token) {
    this.setInSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME, username);
    this.setupAxiosInterceptors(this.createJWTToken(token));
  }

  createJWTToken(token) {
    return token;
  }

  logout() {
    this.removeFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME);
    this.removeFromSessionStorage(MERCHANT_SESSION_ATTRIBUTE_NAME);
  }

  isUserLoggedIn() {
    let user = this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME);
    if (user === null) return false;
    return true;
  }

  getLoggedInUserName() {
    let user = this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME);
    if (user === null) return "";
    return user;
  }

  setupAxiosInterceptors(token) {
    axios.interceptors.request.use((config) => {
      if (this.isUserLoggedIn()) {
        config.headers.authorization = token;
      }
      return config;
    });
  }

  downloadMerchantDoc(docId, docName) {
    axios({
      method: "post",
      url: API_URL + "/admfns/merchantDocumentData",
      responseType: "blob",
      data: {
        id: docId,
        fileName: docName,
      },
    }).then((response) => {
      const file = new Blob([response.data]);
      //Build a URL from the file
      /*   const fileURL = URL.createObjectURL(file); */
      var link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = docName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  approveMerchant(merchantId) {
    return axios.post(API_URL + "/admfns/approveMerchant", {
      merchantId: merchantId,
    });
  }

  fetchTransactionsXL(
    localFromDate,
    localToDate,
    fromTime,
    toTime,
    statuses,
    orderNo,
    email,
    terminalId,
    allChbk,
    accountPoolId,
    acquirerAccountId,
    acquirerTxnId,
    criteriaTxnId,
    numberRowPerPage,
    pageNumber
  ) {
    axios({
      method: "post",
      url: API_URL + "/reports/fetchTransactionXL",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        localFromDate: localFromDate,
        localToDate: localToDate,
        fromTime: fromTime,
        toTime: toTime,
        statuses: statuses,
        orderNo: orderNo,
        email: email,
        terminalId: terminalId,
        allChbk: allChbk,
        accountPoolId: accountPoolId,
        acquirerAccountId: acquirerAccountId,
        acquirerTxnId: acquirerTxnId,
        criteriaTxnId: criteriaTxnId,
        numberRowPerPage: numberRowPerPage,
        pageNumber: pageNumber,
      },
    })
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download =
          "transactions_" + localFromDate + "_" + localToDate + ".xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchTransactionsCSV(
    localFromDate,
    localToDate,
    fromTime,
    toTime,
    statuses,
    orderNo,
    email,
    terminalId,
    allChbk,
    accountPoolId,
    acquirerAccountId,
    acquirerTxnId,
    criteriaTxnId,
    numberRowPerPage,
    pageNumber
  ) {
    axios({
      method: "post",
      url: API_URL + "/reports/fetchTransactionCSV",
      responseType: "blob",
      data: {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        localFromDate: localFromDate,
        localToDate: localToDate,
        fromTime: fromTime,
        toTime: toTime,
        statuses: statuses,
        orderNo: orderNo,
        email: email,
        terminalId: terminalId,
        allChbk: allChbk,
        accountPoolId: accountPoolId,
        acquirerAccountId: acquirerAccountId,
        acquirerTxnId: acquirerTxnId,
        criteriaTxnId: criteriaTxnId,
        numberRowPerPage: numberRowPerPage,
        pageNumber: pageNumber,
      },
    })
      .then((response) => {
        const file = new Blob([response.data], { type: "application/text" });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download =
          "transactions_" + localFromDate + "_" + localToDate + ".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  fetchMerchantTransactionSummary(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    terminalId,
    isReported
  ) {
    return axios.post(API_URL + "/reports/fetchMerchantTransactionSummary", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      refundFromDate: refundFromDate,
      refundFromTime: refundFromTime,
      refundToDate: refundToDate,
      refundToTime: refundToTime,
      chbkFromDate: chbkFromDate,
      chbkFromTime: chbkFromTime,
      chbkToDate: chbkToDate,
      chbkToTime: chbkToTime,
      terminalId: terminalId,
      isReported: isReported,
    });
  }

  markDeclinedSettled(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    terminalId
  ) {
    return axios.post(API_URL + "/reports/markDeclinedSettled", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      refundFromDate: refundFromDate,
      refundFromTime: refundFromTime,
      refundToDate: refundToDate,
      refundToTime: refundToTime,
      chbkFromDate: chbkFromDate,
      chbkFromTime: chbkFromTime,
      chbkToDate: chbkToDate,
      chbkToTime: chbkToTime,
      terminalId: terminalId,
    });
  }

  fetchMerchantTransactionSummaryByAcquirerAccount(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    acquirerAccountId,
    accountPoolId,
    isReported
  ) {
    return axios.post(
      API_URL + "/reports/fetchMerchantTransactionSummaryByAcquirerAccount",
      {
        merchantId: this.getFromSessionStorage(
          USER_NAME_SESSION_ATTRIBUTE_NAME
        ),
        fromDate: fromDate,
        fromTime: fromTime,
        toDate: toDate,
        toTime: toTime,
        refundFromDate: refundFromDate,
        refundFromTime: refundFromTime,
        refundToDate: refundToDate,
        refundToTime: refundToTime,
        chbkFromDate: chbkFromDate,
        chbkFromTime: chbkFromTime,
        chbkToDate: chbkToDate,
        chbkToTime: chbkToTime,
        acquirerAccountId: acquirerAccountId,
        accountPoolId: accountPoolId,
        isReported: isReported,
      }
    );
  }

  markDeclinedSettledByAcquirer(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    acquirerAccountId,
    accountPoolId
  ) {
    return axios.post(API_URL + "/reports/markDeclinedSettledByAcquirer", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      refundFromDate: refundFromDate,
      refundFromTime: refundFromTime,
      refundToDate: refundToDate,
      refundToTime: refundToTime,
      chbkFromDate: chbkFromDate,
      chbkFromTime: chbkFromTime,
      chbkToDate: chbkToDate,
      chbkToTime: chbkToTime,
      acquirerAccountId: acquirerAccountId,
      accountPoolId: accountPoolId,
    });
  }

  markSuccessSettledByAcquirer(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    acquirerAccountId,
    accountPoolId
  ) {
    return axios.post(API_URL + "/reports/markSuccessSettledByAcquirer", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      refundFromDate: refundFromDate,
      refundFromTime: refundFromTime,
      refundToDate: refundToDate,
      refundToTime: refundToTime,
      chbkFromDate: chbkFromDate,
      chbkFromTime: chbkFromTime,
      chbkToDate: chbkToDate,
      chbkToTime: chbkToTime,
      acquirerAccountId: acquirerAccountId,
      accountPoolId: accountPoolId,
    });
  }
  markRRSettledByAcquirer(
    fromDate,
    fromTime,
    toDate,
    toTime,
    refundFromDate,
    refundFromTime,
    refundToDate,
    refundToTime,
    chbkFromDate,
    chbkFromTime,
    chbkToDate,
    chbkToTime,
    acquirerAccountId,
    accountPoolId
  ) {
    return axios.post(API_URL + "/reports/markRRSettledByAcquirer", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      refundFromDate: refundFromDate,
      refundFromTime: refundFromTime,
      refundToDate: refundToDate,
      refundToTime: refundToTime,
      chbkFromDate: chbkFromDate,
      chbkFromTime: chbkFromTime,
      chbkToDate: chbkToDate,
      chbkToTime: chbkToTime,
      acquirerAccountId: acquirerAccountId,
      accountPoolId: accountPoolId,
    });
  }

  reconTransactions(fromDate, fromTime, toDate, toTime, acquirerAccountId) {
    return axios.post(API_URL + "/admfns/verifyAndCorrectByAcquirerAccount", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      fromDate: fromDate,
      fromTime: fromTime,
      toDate: toDate,
      toTime: toTime,
      acquirerAccountIds: acquirerAccountId,
    });
  }

  fetchWireSummary(fromDate, toDate, terminalId) {
    return axios.post(API_URL + "/wire/fetchWireSummary", {
      fromDate: fromDate,
      toDate: toDate,
      terminalId: terminalId,
    });
  }

  refundMerchantTransaction(transactionId, reason, refundAmount) {
    return axios.post(API_URL + "/reports/refundMerchantTransaction", {
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      merchantTransactionId: transactionId,
      reason: reason,
      refundAmount: refundAmount,
    });
  }

  downloadDisputeFile(disputeId, fileId, name) {
    return axios
      .post(
        API_URL + "/admfns/downloadDisputeFile",
        {
          disputeId: disputeId,
          fileId: fileId,
        },
        { responseType: "blob" } // Specify the response type as 'blob'
      )
      .then((response) => {
        const file = new Blob([response.data], {
          type: response.data.type, // Use the correct MIME type
        });

        var link = document.createElement("a");
        link.href = URL.createObjectURL(file);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  reportDisputeTransaction(
    transactionId,
    disputeInitiator,
    disputeInfo,
    amount
  ) {
    return axios.post(API_URL + "/admfns/reportDispute", {
      //merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      transactionId: transactionId,
      disputeInitiator: disputeInitiator,
      disputeInfo: disputeInfo,
      amount: amount,
    });
  }

  fetchDisputeInfo(transactionId) {
    return axios.post(API_URL + "/admfns/disputeInfo", {
      //merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      transactionId: transactionId,
    });
  }

  fetchMarkSettled(disputeId) {
    return axios.post(API_URL + "/admfns/settelDisputes", {
      //merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      disputeId: disputeId,
    });
  }

  addAmendUser(request) {
    return axios.post(API_URL + "/user/addUser", {
      loggerInUser: this.getFromSessionStorage(
        USER_NAME_SESSION_ATTRIBUTE_NAME
      ),
      merchantId: this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME),
      request: request,
    });
  }
  migrateUser(migrationMerchantId) {
    return axios.get(
      API_URL +
        "/user/migrateUser?migrationMerchantId=" +
        migrationMerchantId +
        "&merchantId=" +
        this.getFromSessionStorage(USER_NAME_SESSION_ATTRIBUTE_NAME)
    );
  }
}

export default new ApiService();

//
